import { MessagesService } from '../messages/messages.service';

// The server adds clash_warning when a saved edit leaves the car booked twice.
export function showClashWarning ( messagesService : MessagesService, loan : { clash_warning ?: string } ) : void {
  if ( loan && loan.clash_warning ) {
    messagesService.show(loan.clash_warning, 'warning');
  }
}
